/**
 * DeliveryStatusBadge.jsx — Phase 2B
 * Consistent status pill across all delivery entities.
 */
import React from "react";

const STATUS_CONFIG = {
  DRAFT:      { color: "bg-slate-700/60 text-slate-300 border-slate-600/50",  dot: "bg-slate-400"   },
  PUBLISHED:  { color: "bg-sky-900/60 text-sky-300 border-sky-700/50",        dot: "bg-sky-400"     },
  OPEN:       { color: "bg-emerald-900/60 text-emerald-300 border-emerald-700/50", dot: "bg-emerald-400" },
  CLOSED:     { color: "bg-orange-900/60 text-orange-300 border-orange-700/50",   dot: "bg-orange-400"  },
  ARCHIVED:   { color: "bg-slate-800/60 text-slate-500 border-slate-700/40",  dot: "bg-slate-600"   },
  CANCELLED:  { color: "bg-red-900/60 text-red-300 border-red-700/50",        dot: "bg-red-400"     },
  SCHEDULED:  { color: "bg-indigo-900/60 text-indigo-300 border-indigo-700/50",   dot: "bg-indigo-400"  },
  SUSPENDED:  { color: "bg-yellow-900/60 text-yellow-300 border-yellow-700/50",   dot: "bg-yellow-400"  },
  CONFIRMED:  { color: "bg-teal-900/60 text-teal-300 border-teal-700/50",     dot: "bg-teal-400"    },
  ASSIGNED:   { color: "bg-blue-900/60 text-blue-300 border-blue-700/50",     dot: "bg-blue-400"    },
  ACTIVE:     { color: "bg-green-900/60 text-green-300 border-green-700/50",  dot: "bg-green-400"   },
  REVOKED:    { color: "bg-red-900/60 text-red-300 border-red-700/50",        dot: "bg-red-400"     },
  COMPLETED:  { color: "bg-purple-900/60 text-purple-300 border-purple-700/50", dot: "bg-purple-400"  },
  ELIGIBLE:   { color: "bg-emerald-900/60 text-emerald-300 border-emerald-700/50", dot: "bg-emerald-400" },
  INELIGIBLE: { color: "bg-red-900/60 text-red-300 border-red-700/50",        dot: "bg-red-400"     },
  REQUIRES_REVIEW: { color: "bg-amber-900/60 text-amber-300 border-amber-700/50", dot: "bg-amber-400" },
  PENDING:    { color: "bg-amber-900/60 text-amber-300 border-amber-700/50",  dot: "bg-amber-400"   },
  WITHDRAWN:  { color: "bg-slate-800/60 text-slate-400 border-slate-700/40",  dot: "bg-slate-500"   },
  NOT_STARTED: { color: "bg-slate-700/60 text-slate-300 border-slate-600/50", dot: "bg-slate-400"   },
  IN_PROGRESS: { color: "bg-sky-900/60 text-sky-300 border-sky-700/50",       dot: "bg-sky-400 animate-pulse" },
  SUBMITTED:  { color: "bg-green-900/60 text-green-300 border-green-700/50",  dot: "bg-green-400"   },
  VOIDED:     { color: "bg-red-900/60 text-red-300 border-red-700/50",        dot: "bg-red-400"     },
  ABANDONED:  { color: "bg-orange-900/60 text-orange-300 border-orange-700/50", dot: "bg-orange-400"  },
};

export function DeliveryStatusBadge({ status, size = "sm" }) {
  const cfg = STATUS_CONFIG[status] ?? STATUS_CONFIG.DRAFT;
  const textSize = size === "xs" ? "text-[10px]" : "text-xs";
  const padding  = size === "xs" ? "px-1.5 py-0.5" : "px-2 py-0.5";
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border font-medium ${textSize} ${padding} ${cfg.color}`}
          data-testid={`status-badge-${status}`}>
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${cfg.dot}`} />
      {status.replace(/_/g, " ")}
    </span>
  );
}
